// extracted by mini-css-extract-plugin
export default {"config":"Config_config__-9od4","name":"Config_name__ZAo5Z","forceNegative":"Config_forceNegative__nuQSE","generateButton":"Config_generateButton__mmJXr"};